import React from 'react';
import { Box, Button, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { ChevronLeftRounded, ChevronRightRounded } from '@mui/icons-material';
import ProductCard from './ProductCard';

export default function ProductGrid({ productos = [], cargando, onAgregar, pagina = 1, totalPaginas = 1, onPagina }) {
  if (cargando) {
    return (
      <Box sx={{ flex: 1, minHeight: 280, display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', borderRadius: 1.8, p: 0.1 }}>
        {!productos.length ? (
          <Box sx={{ height: '100%', minHeight: 280, display: 'grid', placeItems: 'center', textAlign: 'center', color: 'text.secondary' }}>
            <Box>
              <Typography variant="h6" fontWeight={900} color="text.primary">No hay productos para mostrar</Typography>
              <Typography variant="body2">Use Buscar, cambie de categoría o marque un código de barras.</Typography>
            </Box>
          </Box>
        ) : (
          <Grid
            container
            spacing={1.05}
            sx={{
              alignContent: 'start',
              '@media (max-height: 820px)': {
                '& > .MuiGrid-item': { pt: '6px', pl: '6px' },
                width: 'calc(100% + 6px)',
                ml: '-6px',
                mt: '-6px',
              },
            }}
          >
            {productos.slice(0, 6).map((producto) => (
              <Grid item xs={6} md={4} key={producto.id || `${producto.sku}-${producto.codigoBarras}`} sx={{ display: 'flex' }}>
                <Box sx={{ width: '100%' }}>
                  <ProductCard producto={producto} onAgregar={onAgregar} />
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        sx={{
          pt: 0.75,
          mt: 'auto',
          borderTop: '1px solid #d8e3ef',
          '@media (max-height: 820px)': { pt: 0.5 },
        }}
      >
        <Button
          variant="outlined"
          size="large"
          startIcon={<ChevronLeftRounded />}
          disabled={pagina <= 1 || totalPaginas <= 1}
          onClick={() => onPagina?.(pagina - 1)}
          sx={{
            minWidth: 118,
            borderRadius: 1.6,
            fontWeight: 900,
            borderColor: '#d2dfed',
            color: '#516982',
            bgcolor: '#fff',
            '@media (max-height: 820px)': { minWidth: 104, minHeight: 34, py: 0.4 },
          }}
        >
          Anterior
        </Button>

        <Typography variant="body2" fontWeight={900} sx={{ color: '#20364f' }}>
          Página {pagina} de {Math.max(1, totalPaginas)}
        </Typography>

        <Button
          variant="contained"
          size="large"
          endIcon={<ChevronRightRounded />}
          disabled={pagina >= totalPaginas || totalPaginas <= 1}
          onClick={() => onPagina?.(pagina + 1)}
          sx={{
            minWidth: 118,
            borderRadius: 1.6,
            fontWeight: 900,
            bgcolor: '#1772e8',
            boxShadow: '0 5px 14px rgba(23,114,232,.17)',
            '&:hover': { bgcolor: '#0f63cf' },
            '@media (max-height: 820px)': { minWidth: 104, minHeight: 34, py: 0.4 },
          }}
        >
          Siguiente
        </Button>
      </Stack>
    </Box>
  );
}
